module.exports = __webpack_public_path__ + "static/media/1.Submersible pumps -V3,V4,V5,V6.ab9c8ffc.jpg";